import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsDepartment, PmsDepartment } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsDepartment>
    useData={usePmsDepartment}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
